// Older components read `original`. For Baigun, point it at Tokko's lighter
// `image` URL in every property, development and unit returned by middleware v2.
const NO_IMAGE = 'https://mediahaus.com.ar/noimage.jpg'

export const preferBaigunTokkoImages = <T>(data: T): T => {
  if (process.env.GATSBY_TENANTID !== '91' || !data || typeof data !== 'object') return data
  if (Array.isArray(data)) return data.map(preferBaigunTokkoImages) as T

  const value = data as Record<string, any>
  const result = { ...value }
  for (const key of ['photos', 'blueprints']) {
    if (Array.isArray(value[key])) {
      result[key] = value[key].map((photo: { image?: string; original?: string }) => {
        const image = photo.image || NO_IMAGE
        return { ...photo, image, original: image }
      })
    }
  }
  for (const key of ['objects', 'properties', 'development']) {
    if (value[key]) result[key] = preferBaigunTokkoImages(value[key])
  }
  return result as T
}
